var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.34021C4.17157 3.34021 3.5 4.01178 3.5 4.84021V14.8402C3.5 16.2209 4.61929 17.3402 6 17.3402H15.5C16.6046 17.3402 17.5 16.4448 17.5 15.3402V7.34021C17.5 6.59993 17.0978 5.95358 16.5 5.60777V5.34021C16.5 4.23564 15.6046 3.34021 14.5 3.34021H5ZM15.5 5.34021H5C4.72386 5.34021 4.5 5.11635 4.5 4.84021C4.5 4.56407 4.72386 4.34021 5 4.34021H14.5C15.0523 4.34021 15.5 4.78793 15.5 5.34021ZM14 11.3402H15C15.2761 11.3402 15.5 11.5641 15.5 11.8402C15.5 12.1164 15.2761 12.3402 15 12.3402H14C13.7239 12.3402 13.5 12.1164 13.5 11.8402C13.5 11.5641 13.7239 11.3402 14 11.3402Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.b2957b9c1d3ef1e64b501748aea0b927.svg";
export { ForwardRef as ReactComponent };